module.exports = __webpack_public_path__ + "img/bg_head.33a11c96.png";